import { useEffect, useRef } from "react";
import styles from "./FeedbackModal.module.css";
import Button from "../Button/Button";

const ICON_CLASS = {
  success: styles.success,
  error: styles.error,
  info: styles.info,
};

export default function FeedbackModal({
  open = false,
  onClose = () => {},
  title = "Notice",
  message = "",
  type = "info",
  confirmText = "OK",
}) {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (open) {
      const original = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      dialogRef.current?.focus();
      return () => {
        document.body.style.overflow = original;
      };
    }
  }, [open]);

  if (!open) return null;

  const iconClass = ICON_CLASS[type] ?? styles.info;
  const iconChar =
    type === "success" ? "\u2713" : type === "error" ? "!" : "i";

  return (
    <div
      className={styles.overlay}
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="feedback-modal-title"
        aria-describedby="feedback-modal-desc"
        tabIndex={-1}
        ref={dialogRef}
      >
        <div className={styles.header}>
          <div
            className={`${styles.icon} ${iconClass}`}
            aria-hidden="true"
          >
            {iconChar}
          </div>
          <h3 id="feedback-modal-title" className={styles.title}>
            {title}
          </h3>
        </div>

        <div id="feedback-modal-desc" className={styles.body}>
          {typeof message === "string" ? <p>{message}</p> : message}
        </div>

        <div className={styles.footer}>
          <Button type="button" onClick={onClose}>
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
}
